module.exports = __webpack_public_path__ + "img/h-test.031f0f94.png";